let initialState = {
    isLoginSectionOpen: false,
}

const modalStates = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_LOGIN_MODAL':
            return {
                ...state,
                isLoginSectionOpen: true,
            }
        case 'CLOSE_LOGIN_MODAL':
            return {
                ...state,
                isLoginSectionOpen: false,
            }
        default:
            return state
    }
}

export default modalStates
